import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Http, Headers, Response, RequestOptions} from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ProductCategorySummaryService {
  private url: string =  environment.appUrl;
  constructor(
    private http: HttpClient
  ) { }

  getSummary(productCatStatus: number) {
    const getSummaryUrl = this.url + 'product-cats?status=' + productCatStatus;
    return this.http
      .get(getSummaryUrl, {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/summary/product-category-summary.service.ts